import * as CubeTree from '../../../cubeTree/index';
import Select from '../../select/index';

function moveGoodsSelect(beAddedCube: CubeNode, task: InsertInfo): void {
    if (CubeTree.isPartition(task.targetId)) {
        // 把层板下的商品选择态干掉
        let removeSelectCubes: Array<CubeId> = CubeTree.findAllChildren(task.targetId);

        Select.removeGroup(removeSelectCubes);
        Select.addOne(beAddedCube.id);
    }
    else if (CubeTree.isGoods(task.targetId)
        || CubeTree.isTextarea(task.targetId)
        || CubeTree.isBafflePlate(task.targetId)) {
        Select.removeGroup([task.targetId]);
        Select.addOne(beAddedCube.id);
    }
}

export {
    moveGoodsSelect
};
